/**
 *  holds gift voucher id. No subscription
 */
export const giftVoucherOffers = [
  'hhwywa3u',
  'LLUt6CjT',
  'p6CQdULb',
  'CZwgc9tz',
  'z8ZTLM2h',
  'qosaWViF',
  'bqQEcAj4',
];

/**
 *  holds the annual subscription membership offer ids
 */
export const annualMembershipOffers = [
  '2NCZS3x3', // USD | Single Subscription
  '9iNuNo3X', // EUR | Single Subscription
  'WqbuEhE9', // JPY | Single Subscription
  'A95xrgaS', // CAD | Single Subscription
  'wZptdbkS', // GBP | Single Subscription
  '4a3sxA5Z', // MXN | Single Subscription
  'Kskze32j', // BRL | Single Subscription
  'CxFDYncJ', // AUD | Single Subscription
  'wXSQgyKM', // EUR | Upgrade to Unlimited Access
  'GLbnEk2h', // USD | Upgrade to Unlimited Access
  'JviivCR7', // EUR | Redeem Gift Voucher
  '9sipkvyz', // USD | Redeem Gift Voucher
  'H2ntpiyF', // USD | Education offer
  'uAtCDu2i', // USD | Subscription - Refund Offer
  'hQrTZuBR', // EUR | Subscription - Refund offer
  'XyUUR2SV', // JPY | Subscription - Refund offer
  'i4VpVWPk', // USD | VIP Family & Friends Private LINK (100% Discount)
  'KxC7Q7Wj', // VidApp - In-App Subscription ANNUAL
];

/** holds the duo subscription membership offer ids */
export const duoMembershipOffers = [
  'yRc8CMCS', // USD
  'f2D2YbCm', // EUR
  '2KzCit2p', // CAD
  'sMzcQs8K', // GBP
  '5NF2r2kz', // MXN
  'MGQEFXyL', // BRL
  '7Foj7yGB', // AUD
  'Y6GR9bxU', // JPY
];

/** DUO membership with Annual payment (NEW as of Feb. 2024)*/
export const duoAnnualMembershipOffers = [
  'w2fifDRT', // USD
  'Qimf96sq', // EUR
  'WwHiwpHG', // USD with coupon
  'mB3tJGTb', // EUR with coupon
];

/** holds the monthly subscription membership offer ids */
export const monthlyMembershipOffers = [
  'NzA7QKF3', // USD
  'AQHzjrJ9', // JPY
  'gYTKYqSW', // EUR
  'LEM7QhGt', // CAD
  'apWPYcuU', // GBP
  'uckUTVWE', // MXN
  'ufAztbbJ', // BRL
  'rR4unXLN', // AUD
];
